// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"2d3a9925","3357":"3bf09490","3362":"41eb71e2","3883":"5853fa6a","3924":"41eb71e2","9916":"ca2f365c"}[chunkId] + ".chunk.css";
};